<template>
    <div class="indexBox">
        <!-- 数智实验室 -->
        <div class="labSection">
            <iframe :src="labUrl" frameborder="0" scrolling="auto"></iframe>
        </div>
        <div class="sessionOneBox">
            <el-carousel autoplay :height="height">
                <el-carousel-item>
                    <img src="@/assets/index/sessionOneBg.png" alt="">
                </el-carousel-item>
                <el-carousel-item>
                    <img src="@/assets/index/banner2.png" alt="">
                </el-carousel-item>
                <el-carousel-item>
                    <img src="@/assets/index/banner3.png" alt="">
                </el-carousel-item>
            </el-carousel>
        </div>
        <!-- 业务范围 -->
       <business></business>
       <!-- 媒体中心 -->
       <media v-if="!isMobile"></media>
       <media-wx v-if="isMobile"></media-wx>
       <!-- 瑞和在中国 -->
       <mapshow></mapshow>
    </div>
</template>

<script>
    import business from './components/business'
    import media from './components/media'
    import mediaWx from './components/media-wx'
    import mapshow from './components/mapshow'
	export default {
		name:'Index',
        components:{business,media,mediaWx,mapshow},
        data() {
            return {
                height: '570px',
                labUrl: window.location.origin + '/szsys/#/index?layout=compact',
            }
        },
        mounted() {
            var height = window.innerHeight
            if(this.isMobile){
                this.height = '170px'
            }else{
                this.height = height*570/931+'px'
            }
        },
        methods: {
           
        },
	}
</script>
<style scoped lang="less">
    .indexBox {
        background: #F8F8F8;
    }
    .sessionOneBox{
        width: 100%;
        cursor: pointer;
    }
    .sessionOneBox img{
        width: 100%;
        height: 100%;
    }
    .sessionOneBox /deep/.el-carousel__indicators--horizontal{
        bottom: 10px;
    }

    .labSection {
        width: 100%;
        overflow: hidden;
    }
    .labSection iframe {
        width: 100%;
        height: 730px;
        border: none;
    }
</style>
